import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import AccordionBox from '../components/AccordionBox';
import { WOW } from 'wowjs';
import 'animate.css';

const faqLeft = [
  { question: 'What warranties do I have for installation?', answer: 'There are many variations of passages of available, but the majority have suffered alteration in some form.' },
  { question: 'What is included in your services?', answer: 'There are many variations of passages of available, but the majority have suffered alteration in some form.' },
  { question: 'What are the payment methods?', answer: 'There are many variations of passages of available, but the majority have suffered alteration in some form.' },
  { question: 'How fast I get my order?', answer: 'There are many variations of passages of available, but the majority have suffered alteration in some form.' },
];

const faqRight = [
  { question: 'Produce Your Own Clean Save The Environment', answer: 'Reduce, reuse, and recycle: This is a classic but effective way to reduce waste and conserve resources. Try to use reusable bags, containers, and water bottles, and recycle items that can\'t be reused.' },
  { question: 'On-Site Service And Support For Certification', answer: 'On-site service and support for certification refers to the assistance provided to companies or organizations that are seeking certification for their products, services, or processes.' },
  { question: 'Light Source For Stable Conversion Efficiency', answer: 'In the context of solar energy, a light source for stable conversion efficiency refers to a source of light that provides a consistent and predictable output, which can be used to test and optimize the performance of solar cells and panels.' },
  { question: 'Do You Give Guarantee And After Sales Service?', answer: 'Many companies that offer products or services do provide guarantees and after-sales service to their customers. Guarantees are a form of assurance that a product or service will meet certain expectations or standards.' },
];

export default function Faq() {
  useEffect(() => {
    const wow = new WOW({ mobile: false, live: true });
    wow.init();
  }, []);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header style="two" />
      <PageTitle title="FAQ" breadcrumbs={[{ label: 'Pages', path: '#' }, { label: 'FAQ' }]} />

      <section className="faqs-section-home1 mt-0 pt-120 pb-60 pb-md-20">
        <div className="auto-container">
          <div className="row">
            <div className="faq-column col-lg-6">
              <div className="inner-column">
                <AccordionBox items={faqLeft} styleClass="style-two wow fadeInLeft" />
              </div>
            </div>
            <div className="faq-column col-lg-6">
              <div className="inner-column mb-md-50">
                <AccordionBox items={faqRight} styleClass="style-two bg-transparent p-0 wow fadeInLeft" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
